// ListFooterActions — fila de acciones al pie de una lista ("[Exportar] [Mapa de tiendas]" en B01;
// "[Exportar]" en B02/B06/B10). Contenedor de botones secundarios alineados; el caller pasa los
// <Button> que correspondan a cada pantalla.
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export interface ListFooterActionsProps {
    children: ReactNode;
    className?: string;
}

export function ListFooterActions({ children, className }: ListFooterActionsProps) {
    return (
        <div className={cn('flex flex-wrap items-center gap-2 pt-1', className)}>{children}</div>
    );
}
